<template>
    <div :class="`alert alert-${alert.color}`">
        <button aria-hidden="true" class="close" data-dismiss="alert" type="button">×</button>
        <strong><i :class="`fa ${alert.icon}`"></i> {{ alert.title }}</strong> {{ alert.subtitle }}
    </div>
</template>

<script>
import AlertTypes from './consts/alert_types';
export default {
    name: 'Alert',

    props: {
        alertType: {
            required: true,
            type: String,
        },
    },

    data() {
        return {
            [AlertTypes.ACCOUNT_FOUND]: {
                color: 'success',
                icon: 'fa-check',
                subtitle: 'We noticed you have an account. Please login.',
                title: 'Account Found',
            },
            [AlertTypes.LOGIN_ERROR]: {
                color: 'danger',
                icon: 'fa-times',
                subtitle: 'The login details were incorrect',
                title: 'Incorrect Login',
            },
            [AlertTypes.REGISTER_ERROR]: {
                color: 'danger',
                icon: 'fa-times',
                subtitle: 'Please ensure you have entered matching passwords and agreed to the terms and conditions.',
                title: 'Unable to create account.',
            },
        }
    },

    computed: {
        alert() {
            return this[this.alertType];
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Users/LoginOrSignup/Alert.vue